import { useEffect, useState } from "react";

//interfaces
import { ActionFeedback } from "thrive-components";
import { IUseRecognitionNotification } from "@/interfaces/activityFeedNotifications";

//helpers
import { useHaltPropagation } from "@/components/hooks/utility/useHaltPropagation";
import { getContentDeletedBannerMessage, getUserDetails } from "@/helpers/ActivityFeed";



const UseRecognitionPost = ({isPopOut, timeStamp, dateStamp, parentList, content, onLikeClick, onPostCommentClick, onArchiveContentClick, isRemovedFromParentList, appDetails, getWebLink, meta, recognition, notificationDetails, isModeratedContent, needsApproval, onApproveClick} : IUseRecognitionNotification) => {
    const [showCommentFunctionality, setShowCommentFunctionality] = useState<boolean>(false);
    const [showArchiveContent, setShowArchiveContent] = useState<boolean>(false);
    const [commentString, setCommentString] = useState<string>("");
    const [isPosting, setIsPosting] = useState<boolean>(false);
    const contentIsRemoved = isRemovedFromParentList || content.isArchived;
    const contentIsPublished = isModeratedContent ? !contentIsRemoved && !needsApproval : !contentIsRemoved;
    const showApprovalPanel = isPopOut ? !showArchiveContent && !contentIsRemoved && isModeratedContent : !contentIsRemoved && isModeratedContent
    const screenClassName = !isPopOut ? "full-screen-styling" : "";
    const showMenu = !content.isArchived
    const recognisedUser = getUserDetails(recognition.recognisedUser)
    const showFeedbackBanner : boolean = !!notificationDetails;
    const feedbackType = notificationDetails?.isSuccess ? ActionFeedback.SUCCESS : ActionFeedback.ERROR;
    const feedbackMessage = notificationDetails?.message ?? '';
    const deletedBannerMessage = getContentDeletedBannerMessage(needsApproval, isModeratedContent, content?.isArchived, parentList?.title);
    const activityInfo = {
        className:screenClassName,
        time: isPopOut ? timeStamp : undefined,
        dateStamp: `${timeStamp} · ${dateStamp}`,
        appImageUrl: appDetails.isMultipleAppOrganisation ? appDetails.iconUrl : "",
        appName: appDetails.isMultipleAppOrganisation ? appDetails.name : "",
        likes: meta.likeCount,
        comments: meta.commentCount,
        recognitionValue: recognition.value,
        commentsEnabled: meta.commentsEnabled,
        likesEnabled: meta.likesEnabled
    }
    
    const webLink = contentIsPublished ? getWebLink : undefined;
    const handleLikeClick = contentIsPublished && meta.likesEnabled ? onLikeClick : undefined
    const handleApproveClick = !contentIsRemoved && needsApproval ? onApproveClick : undefined
    const handleReplyClick = contentIsPublished && meta.commentsEnabled ? () => setShowCommentFunctionality(true) : undefined
    const handleArchiveClick = !contentIsRemoved ? () => setShowArchiveContent(true) : undefined
    
    useEffect(() => {
        setIsPosting(false);
    }, [notificationDetails?.message]);

    function onCommentClick() {
        setIsPosting(true);
        onPostCommentClick(commentString);
        setShowCommentFunctionality(false);
        setCommentString("");
    }

    function onArchiveClick() {
        onArchiveContentClick();
        setShowArchiveContent(false);
    }

    function hideArchiveFunctionality(e?: any) {
        useHaltPropagation(e);
        setShowArchiveContent(false);
    }

    return {recognisedUser, screenClassName, webLink, handleLikeClick, handleReplyClick, handleArchiveClick, handleApproveClick, showMenu, commentString, setCommentString, onCommentClick, showCommentFunctionality, setShowCommentFunctionality, showFeedbackBanner, feedbackType,  feedbackMessage, contentIsRemoved, deletedBannerMessage, showApprovalPanel, showArchiveContent, hideArchiveFunctionality, onArchiveClick, activityInfo, isPosting}
};

export default UseRecognitionPost